<div class="page-layout carded fullwidth inner-scroll">
  <div class="center">
    <div class="header">
      <span class="h1">{{ 'EQUIPMENTS.TITLE' | translate }}</span>

      <div class="page-buttons">
        <button
          mat-stroked-button
          matTooltip="{{ 'EQUIPMENTS.ADD' | translate }}"
          [disabled]="!hasCreateEquipmentPermission"
          (click)="openDialog()"
        >
          <i
            matTooltipPosition="left"
            class="angularjs-fuse-icon icon-plus"
            [matTooltip]="'EQUIPMENTS.PERMISSIONS.NO_CREATE' | translate"
            [matTooltipDisabled]="hasCreateEquipmentPermission"
          ></i>
        </button>

        <button
          *ngIf="hasCreateExportPermission"
          mat-stroked-button
          matTooltip="{{ 'EQUIPMENTS.EXPORT_EXCEL' | translate }}"
          (click)="openExportDialog()"
          [disabled]="!totalCount"
        >
          <i class="angularjs-fuse-icon icon-file-excel"></i>
        </button>

        <button
          *ngIf="filtered"
          mat-stroked-button
          matTooltip="{{ 'EQUIPMENTS.FILTER_CLEAR' | translate }}"
          (click)="clearFilters()"
        >
          <i class="angularjs-fuse-icon icon-filter-remove"></i>
        </button>

        <button
          mat-stroked-button
          matTooltip="{{ 'EQUIPMENTS.FILTER.TITLE' | translate }}"
          (click)="sidenavService.open('filterEquipments')"
        >
          <i class="angularjs-fuse-icon icon-filter"></i>
        </button>

        <button mat-stroked-button matTooltip="{{ 'EQUIPMENTS.RELOAD' | translate }}" (click)="reload()">
          <i class="angularjs-fuse-icon icon-reload small"></i>
        </button>
      </div>
    </div>

    <div class="content-card datatable">
      <mat-table
        #datatable
        class="datatable__table"
        [dataSource]="equipments"
        fusePerfectScrollbar
        matSort
        [matSortDisableClear]="true"
      >
        <ng-container matColumnDef="imageUrl">
          <mat-header-cell *matHeaderCellDef>
            {{ 'EQUIPMENTS.HEADER.IMAGE' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let equipment">
            <img class="avatar" *ngIf="equipment.imageUrl" [alt]="equipment.name" [src]="equipment.imageUrl" />
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="number">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'EQUIPMENTS.HEADER.NUMBER' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let equipment">
            <span class="mobile-label">{{ 'EQUIPMENTS.HEADER.NUMBER' | translate }}:</span>
            <div
              class="label-color"
              [class.red-500-bg]="equipment.archived"
              [class.green-500-bg]="!equipment.archived"
            ></div>
            <span class="limit-cells" [matTooltip]="equipment.number">
              {{ equipment.number }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'EQUIPMENTS.HEADER.NAME' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let equipment">
            <span class="mobile-label">{{ 'EQUIPMENTS.HEADER.NAME' | translate }}:</span>
            <span class="limit-cells" [matTooltip]="equipment.name">
              {{ equipment.name }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="typeName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'EQUIPMENTS.HEADER.TYPE' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let equipment">
            <span class="mobile-label">{{ 'EQUIPMENTS.HEADER.TYPE' | translate }}:</span>
            <span class="limit-cells" [matTooltip]="equipment.type?.name">
              {{ equipment.type?.name }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="locationName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'EQUIPMENTS.HEADER.LOCATION' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let equipment">
            <span class="mobile-label">{{ 'EQUIPMENTS.HEADER.LOCATION' | translate }}:</span>
            <span class="limit-cells" [matTooltip]="equipment.location?.name">
              {{ equipment.location?.name }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="locationEnvironmentName">
          <mat-header-cell *matHeaderCellDef>
            {{ 'EQUIPMENTS.HEADER.LOCATION_ENVIRONMENT' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let equipment">
            <span class="mobile-label"> {{ 'EQUIPMENTS.HEADER.LOCATION_ENVIRONMENT' | translate }}: </span>
            <span class="limit-cells" [matTooltip]="equipment.locationEnvironment?.name">
              {{ equipment.locationEnvironment?.name }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="warrantyStartDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'EQUIPMENTS.HEADER.WARRANTY_START_DATE' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let equipment">
            <span class="limit-cells" [matTooltip]="equipment.warrantySummary?.startDate | date: 'dd/MM/yyyy'">
              {{ equipment.warrantySummary?.startDate | date: 'dd/MM/yyyy' }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="warrantyEndDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'EQUIPMENTS.HEADER.WARRANTY_END_DATE' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let equipment">
            <span
              class="limit-cells"
              [matTooltip]="
                equipment.warrantySummary?.extendedEndDate || equipment.warrantySummary?.endDate | date: 'dd/MM/yyyy'
              "
            >
              {{
                equipment.warrantySummary?.extendedEndDate || equipment.warrantySummary?.endDate | date: 'dd/MM/yyyy'
              }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="warrantyStatus">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'EQUIPMENTS.HEADER.WARRANTY_STATUS' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let equipment">
            <span class="mobile-label"> {{ 'EQUIPMENTS.HEADER.WARRANTY_STATUS' | translate }}: </span>
            <span class="limit-cells">
              <warranty-status-badge [status]="equipment.warrantySummary?.status"></warranty-status-badge>
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'EQUIPMENTS.HEADER.CREATED_AT' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let equipment">
            <span class="limit-cells" [matTooltip]="equipment.createdAt | date: 'dd/MM/yyyy HH:mm'">
              {{ equipment.createdAt | date: 'dd/MM/yyyy HH:mm' }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="edit">
          <mat-header-cell *matHeaderCellDef fxFlex="5">
            {{ 'EQUIPMENTS.HEADER.ACTIONS' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let equipment" fxFlex="5">
            <span class="mobile-label uppercase">{{ 'EQUIPMENTS.EDIT' | translate }}</span>
            <button
              mat-icon-button
              [matTooltip]="(hasEditEquipmentPermission ? 'EQUIPMENTS.EDIT' : 'EQUIPMENTS.VIEW') | translate"
              (click)="openDialog(equipment.id)"
            >
              <img src="assets/images/icons/new_icon_edit_action.svg" alt="edit equipment" />
            </button>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="noData">
          <mat-footer-cell *matFooterCellDef [attr.colspan]="displayedColumns.length" attr.style.text-align="center">
            {{ 'EQUIPMENTS.NO_DATA' | translate }}
          </mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="loading">
          <mat-footer-cell *matFooterCellDef [attr.colspan]="displayedColumns.length">
            <mat-spinner color="primary" diameter="64" class="m-24"></mat-spinner>
          </mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns" [class.display-none]="loading"></mat-row>
        <mat-footer-row *matFooterRowDef="['noData']" [hidden]="loading || equipments?.length"></mat-footer-row>
        <mat-footer-row *matFooterRowDef="['loading']" [hidden]="!loading || equipments?.length"></mat-footer-row>
      </mat-table>
      <mat-paginator [length]="totalCount" [pageSizeOptions]="[25, 50, 100, 200, 250]"></mat-paginator>
    </div>
  </div>
</div>

<fuse-sidebar name="filterEquipments" position="right" lockedOpen="true">
  <filter-equipments class="sidebar-filter"></filter-equipments>
</fuse-sidebar>
